export default "__VITE_ASSET__CmK3ODr___"